import { styled, Box, BoxProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface GridTableProps extends BoxProps {}

export const GridTable = styled(
  ({ className, children, ...boxProps }: GridTableProps): ReactElement => {
    return (
      <Box className={className} {...boxProps}>
        {children}
      </Box>
    );
  },
)({
  display: 'grid',
  overflow: 'hidden',
});
